import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import type { PlatformStatsData } from 'api/dist/routes/_public/platform-stats'

export type { PlatformStatsData }

/**
 * Public (unauthenticated) platform stats for the logged-out landing "vision" section. Polls the
 * Redis-cached `/platform-stats` endpoint; each new value re-rolls the number wheels. Use
 * `useClientApi()` (not the org/brand-scoped toolbox) since this runs logged-out.
 */
export class GetPlatformStatsQuery {
    static route = '/platform-stats'

    static getKey() {
        return ['public', 'platform-stats']
    }

    static call(api: IApi) {
        return api.get<PlatformStatsData>(GetPlatformStatsQuery.route).then((res) => res?.data)
    }
}

export function useGetPlatformStatsQuery(initialData?: PlatformStatsData) {
    const api = useClientApi()
    return useApiQuery({
        queryKey: GetPlatformStatsQuery.getKey(),
        queryFn: () => GetPlatformStatsQuery.call(api),
        initialData,
        // live poll; matches the endpoint's cache cadence. explicit staleTime avoids an immediate
        // refetch over the SSR-seeded value.
        refetchInterval: 60_000,
        staleTime: 60_000,
    })
}
